import { render, staticRenderFns } from "./GetItemsList.vue?vue&type=template&id=367f0969&"
import script from "./GetItemsList.vue?vue&type=script&lang=js&"
export * from "./GetItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports